import React, { useContext, useEffect, useState } from "react";

import { ASSISTANCE_PRICING } from "shared/config/pricings";
import DocumentIllustration from "components/DocumentIllustration";
import IDAssistantComment from "features/accompaniment/components/IDAssistantComment";
import IDAssistantInfoForm from "features/accompaniment/components/IDAssistantInfoForm";
import IDAssistantPricing from "features/accompaniment/components/IDAssistantPricing";
import IDAssistantSelectDocument from "features/accompaniment/components/IDAssistantSelectDocument";
import IDAssistantStepperMenu from "features/accompaniment/components/IDAssistantStepperMenu/IDAssistantStepperMenu";
import IDAssistantUploadPV from "features/accompaniment/components/IDAssistantUploadPV";
import ResultAfterPayment from "components/ResultAfterPayment";
import { StripePaymentCard } from "features/payment";
import { UserContext } from "features/account";
import { useLocation, useParams } from "react-router-dom";
import { getSubscription } from "features/account";

export default function IDAssistantAdd() {
    const location = useLocation();
    const {offreId: pathOffreId} = useParams()
    const [userLastAccompanimentPaid, setUserLastAccompanimentPaid] = useState<any>(ASSISTANCE_PRICING[1]);

    const { user, getMe } = useContext(UserContext);
    const type = user?.type;

    const [message, setMessage] = useState("");
    const [title, setTitle] = useState("");
    const [pageSucceeded, setPageSucceeded] = useState(false);
    const [datas, setDatas] = useState<any>({
        user: user,
        addresse: "",
        postalCode: "",
        city: "",
        comment: "",
        docNumber: "",
        docCodeCountry: "",
        typeDoc: "",
        birthDate: "",
        birthPlace: "",
        ownerOfThisDoc: false,
        sex: "",
        dateDepotPlainte: "",
        raisons: [],
        plaintesRaisons: [],
        docsToUpload: [],
        documents_ids: [],
        filesToUpload: [],
        chosenPlan: userLastAccompanimentPaid,
    });

    useEffect(() => {
        const getOffer = async () => {
            if (pathOffreId) {
                ASSISTANCE_PRICING.map((offer) => {
                    if (parseInt(pathOffreId) === offer.offreId) {
                        setUserLastAccompanimentPaid(offer);
                        setDatas({...datas, chosenPlan: offer})
                    }
                })
            } else {
                try {
                    const response = await getSubscription(type, user?.email);
                    ASSISTANCE_PRICING.map((offer) => {
                        if (response.data.lastAccompanimentOffer.id === offer.offreId) {
                            setUserLastAccompanimentPaid(offer);
                            setDatas({...datas, chosenPlan: offer})
                        }
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        };

        if (user) {
            getOffer();
        }
    }, [user, type, pathOffreId]);

    const [steps, setSteps] = useState(
      user?.mustRedirectToIDAssistant ?
        [
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
        ] : [
            { isCurrent: true, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
        ]
    );

    useEffect(() => {
        getMe();
        setSteps([
            { isCurrent: true, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
            { isCurrent: false, isDone: false },
        ])
    }, [location.pathname, user?.mustRedirectToIDAssistant]);


    const handleUpdateStep = (step: number) => {
        setSteps(
            steps.map((s, index) => {
                if (index === step) {
                    return { isCurrent: true, isDone: false };
                } else if (index < step) {
                    return { isCurrent: false, isDone: true };
                }
                return { isCurrent: false, isDone: false };
            }),
        );
    };

    const handleNextStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep < steps.length - 1) {
            handleUpdateStep(currentStep + 1);
        }
    };

    const handlePreviousStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep > 0) {
            handleUpdateStep(currentStep - 1);
        }
    };

    const handlePageResult = (title: string, message: string, pageSucceeded: boolean) => {
        handleNextStep();
        setTitle(title);
        setMessage(message);
        setPageSucceeded(pageSucceeded);
        if (pageSucceeded) {

        }
    };

    return (
        <div className="IDAssistantAdd">
            <div className="content__body h-100">
                <div className="row">
                    <div className="col-sm-1">
                        <IDAssistantStepperMenu
                            steps={steps}
                            setSteps={setSteps}
                            handleUpdateStep={handleUpdateStep}
                        />
                    </div>
                    <div className={`col-sm-6`}>
                        {user?.mustRedirectToIDAssistant && (
                          <h5 className={'text-primary text-center text-initial'}>Suite à votre souscription <span className={'text-danger'}>{userLastAccompanimentPaid?.title}</span> </h5>
                        )}
                        <div className="content--card">
                            {steps[0].isCurrent && (
                                <IDAssistantSelectDocument
                                    setDatas={setDatas}
                                    datas={datas}
                                    steps={steps}
                                    handleNextStep={handleNextStep}
                                    handlePreviousStep={handlePreviousStep}
                                    withUploadedDocument={user?.mustRedirectToIDAssistant}
                                />
                            )}

                            {steps[1]?.isCurrent && (
                                <IDAssistantUploadPV
                                    setDatas={setDatas}
                                    datas={datas}
                                    steps={steps}
                                    handleNextStep={handleNextStep}
                                    handlePreviousStep={handlePreviousStep}
                                />
                            )}

                            {steps[2]?.isCurrent && (
                                <IDAssistantInfoForm
                                    setDatas={setDatas}
                                    datas={datas}
                                    steps={steps}
                                    handleNextStep={handleNextStep}
                                    handlePreviousStep={handlePreviousStep}
                                />
                            )}

                            {steps[3]?.isCurrent && (
                                <IDAssistantComment
                                    setDatas={setDatas}
                                    datas={datas}
                                    steps={steps}
                                    handleNextStep={handleNextStep}
                                    handlePreviousStep={handlePreviousStep}
                                    withUploadedDocument={user?.mustRedirectToIDAssistant}
                                    handlePageResult={handlePageResult}
                                />
                            )}

                            {!user?.mustRedirectToIDAssistant && steps[4]?.isCurrent && (
                                <IDAssistantPricing
                                    setDatas={setDatas}
                                    datas={datas}
                                    steps={steps}
                                    handleNextStep={handleNextStep}
                                    handlePreviousStep={handlePreviousStep}
                                />
                            )}
                            {!user?.mustRedirectToIDAssistant && steps[5]?.isCurrent && (
                                <StripePaymentCard
                                    title={`Accompagnement ${datas.chosenPlan.title}`}
                                    link={`${user?.type === 'partner' ? '/professionnels' : '/particuliers'}/id-assistant`}
                                    setDatas={setDatas}
                                    datas={datas}
                                    steps={steps}
                                    handlePaymentResult={handlePageResult}
                                    handlePreviousStep={handlePreviousStep}
                                />
                            )}
                            {((!user?.mustRedirectToIDAssistant && steps[6]?.isCurrent) ||
                              (user?.mustRedirectToIDAssistant && steps[4]?.isCurrent)) && (
                                <ResultAfterPayment
                                    title={title}
                                    message={message}
                                    pageSucceeded={pageSucceeded}
                                    steps={steps}
                                    handlePreviousStep={handlePreviousStep}
                                    handleNextStep={() => (window.location.href = `${user?.type === 'partner' ? '/professionnels' : '/particuliers'}/id-assistant`)}
                                    textBtn={"Accéder à mon dossier"}
                                />
                            )}
                        </div>
                    </div>
                    <div className={`col-sm-5 center`}>
                        <div>
                            {/*<h3 className="text-center mb-4">Remplir mon dossier d'accompagnement</h3>*/}
                            <DocumentIllustration type={"payment"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
